// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/artifactstudio/v1/artifact_studio.proto (package mono.artifactstudio.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AssembleSubmissionPackageRequest, AssembleSubmissionPackageResponse, GenerateFirstDraftRequest, GenerateFirstDraftResponse, GetAssetRequest, GetAssetResponse, ListArtifactTypesRequest, ListArtifactTypesResponse, ListProjectAssetsRequest, ListProjectAssetsResponse, TransitionApprovalRequest, TransitionApprovalResponse } from "./artifact_studio_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ArtifactStudioService is the user-facing (browser → sabaody → tesoro) surface
 * for Artifact Studio. It orchestrates the data plane: rendering a first-draft
 * office file (DOCX/PPTX/XLSX) via go-common/officegen, storing it in MinIO,
 * registering it as a pangaea studio asset, opening a shirohige
 * CollaborativeDocument on the seed bytes, and proxying the approval +
 * packaging flow. The internal row-shaped data plane lives in
 * mono.datagateway.v1.ArtifactStudioGatewayService (pangaea); this service is
 * the orchestration tier the frontend talks to.
 *
 * Tenant + user identity arrive as gateway headers (sabaody → tesoro); callers
 * never pass tenant_id/user_id in the request.
 *
 * @generated from service mono.artifactstudio.v1.ArtifactStudioService
 */ export const ArtifactStudioService = {
    typeName: "mono.artifactstudio.v1.ArtifactStudioService",
    methods: {
        /**
     * ListArtifactTypes returns the artifact types the generator can produce
     * (the picker's options), each with its display name and office format.
     *
     * @generated from rpc mono.artifactstudio.v1.ArtifactStudioService.ListArtifactTypes
     */ listArtifactTypes: {
            name: "ListArtifactTypes",
            I: ListArtifactTypesRequest,
            O: ListArtifactTypesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GenerateFirstDraft renders a first-draft office file for an artifact type,
     * stores it, registers a born-ai_drafted studio asset, opens an editor
     * document on it, and returns the asset plus the document id to open.
     *
     * @generated from rpc mono.artifactstudio.v1.ArtifactStudioService.GenerateFirstDraft
     */ generateFirstDraft: {
            name: "GenerateFirstDraft",
            I: GenerateFirstDraftRequest,
            O: GenerateFirstDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListProjectAssets lists the Artifact Studio assets for a project.
     *
     * @generated from rpc mono.artifactstudio.v1.ArtifactStudioService.ListProjectAssets
     */ listProjectAssets: {
            name: "ListProjectAssets",
            I: ListProjectAssetsRequest,
            O: ListProjectAssetsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetAsset fetches a single studio asset.
     *
     * @generated from rpc mono.artifactstudio.v1.ArtifactStudioService.GetAsset
     */ getAsset: {
            name: "GetAsset",
            I: GetAssetRequest,
            O: GetAssetResponse,
            kind: MethodKind.Unary
        },
        /**
     * TransitionApproval advances an asset's approval state
     * (in_review / approved / rejected). The actor is the request principal.
     *
     * @generated from rpc mono.artifactstudio.v1.ArtifactStudioService.TransitionApproval
     */ transitionApproval: {
            name: "TransitionApproval",
            I: TransitionApprovalRequest,
            O: TransitionApprovalResponse,
            kind: MethodKind.Unary
        },
        /**
     * AssembleSubmissionPackage validates a set of assets for export (refuses
     * any not-approved asset, checks required types) and, when valid, records an
     * audited export and returns the manifest.
     *
     * @generated from rpc mono.artifactstudio.v1.ArtifactStudioService.AssembleSubmissionPackage
     */ assembleSubmissionPackage: {
            name: "AssembleSubmissionPackage",
            I: AssembleSubmissionPackageRequest,
            O: AssembleSubmissionPackageResponse,
            kind: MethodKind.Unary
        }
    }
};
